let Vue = window.Vue;

new Vue({
    el: '#content',
    data () {
        return {
            pageData: window.pageData().news,
            pageIndex: 0,
            showNext:false,
            showPre:false
        };
    },
    mixins: [window.globalMixin, window.utilsMixin],
    created () {
        if (this.pageData.prevNewsId) {
            this.showPre = true;
        }
        if (this.pageData.nextNewsId) {
            this.showNext = true;
        }
    },
    methods: {
        handleCurrentChange(id) {
            if (id === undefined) {
                return;
            } else {
                this.toUrl('/learning/newsDetail?newsId=' + id  + (this.pageData.newTypeId.length > 0 ? '&newTypeId=' + this.pageData.newTypeId : '') + (this.pageData.navTwoId.length > 0 ? '&navId=' + this.pageData.navTwoId : ''));
            }

        },
        format (val) {
            //shijianchuo是整数，否则要parseInt转换
            let time = new Date(val);
            let y = time.getFullYear();
            let m = time.getMonth()+1;
            let d = time.getDate();
            let h = time.getHours();
            let mm = time.getMinutes();
            let s = time.getSeconds();
            return y+'-'+this.add(m)+'-'+this.add(d)+' '+this.add(h)+':'+this.add(mm)+':'+this.add(s);
        },
        add (m) {
            return m<10?'0'+m:m;
        }
    }
});
